import React from "react";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { Typography, Divider } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

// Corpo gravado pelo backend ao enviar o cartao nativo de chave Pix:
//   "‎💠 Chave Pix enviada — {nome}\n{chave}"
const PIX_MARKER = "‎💠 Chave Pix enviada — ";

export const isPixMessage = body =>
	typeof body === "string" && body.startsWith(PIX_MARKER);

export const parsePixMessage = body => {
	const [firstLine, key = ""] = body.split("\n");
	return { name: firstLine.replace(PIX_MARKER, ""), key: key.trim() };
};

const useStyles = makeStyles(theme => ({
	card: {
		minWidth: 220,
		borderRadius: 10,
		overflow: "hidden",
		margin: "2px 0 6px",
		border:
			theme.palette.type === "dark"
				? "1px solid rgba(134, 150, 160, 0.25)"
				: "1px solid rgba(17, 27, 33, 0.12)",
	},
	top: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		padding: "10px 12px",
	},
	icon: {
		width: 32,
		height: 32,
		borderRadius: 8,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#00a884",
		color: "#fff",
		flexShrink: 0,
	},
	name: {
		fontWeight: 600,
		fontSize: "0.85rem",
		lineHeight: 1.3,
	},
	key: {
		fontSize: "0.76rem",
		opacity: 0.75,
		wordBreak: "break-all",
	},
	copyButton: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 6,
		padding: "8px 0",
		color: "#00a884",
		fontWeight: 600,
		fontSize: "0.8rem",
		cursor: "pointer",
		userSelect: "none",
		"&:hover": {
			backgroundColor: "rgba(0, 168, 132, 0.08)",
		},
	},
}));

const PixMessageCard = ({ body }) => {
	const classes = useStyles();
	const { name, key } = parsePixMessage(body);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(key);
			toast.success(i18n.t("pix.dialog.copied"));
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<div className={classes.card}>
			<div className={classes.top}>
				<div className={classes.icon}>
					<AttachMoneyIcon fontSize="small" />
				</div>
				<div>
					<Typography className={classes.name}>{name}</Typography>
					<Typography className={classes.key}>{key}</Typography>
				</div>
			</div>
			<Divider />
			<div className={classes.copyButton} onClick={handleCopy} role="button">
				<FileCopyOutlinedIcon fontSize="small" />
				{i18n.t("pix.dialog.copyKey")}
			</div>
		</div>
	);
};

export default PixMessageCard;
